/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 1:30 PM
 *
 */

import { useQuery } from 'react-query';

import { getRoleDetails } from 'features/members/api/requests/role.request';

export const useRoleDetails = (roleId: number) => {
  return useQuery(['role-details', roleId], () => getRoleDetails(roleId), {
    enabled: roleId !== 0,
    staleTime: 0,
  });
};
